/* eslint-disable max-classes-per-file */
import { assign } from "lodash";
import { meanRoundedWeighted } from "../../atgarder/atgard-forkalkyl/forkalkyl-snabbkalkyl/forkalkyl-snabbkalkyl.component";
import { VKSnabbkalkylmallDTO } from "./snabbkalkylmall-models";
import { VKForkalkylTradslagDTO, VKProduktGruppDTO } from "./tradslag-models";

export interface VKSnabbkalkylUtbyteRequestDTO {
    tradslag: VKSnabbkalkylTradslagDTO[];
    uttagM3FubHa: number;
}

export class VKSnabbkalkylTradslagDTO {
    andel?: number;
    medelstam?: number;
    timmerandel?: number;
    massavedandel?: number;
    granmassavedsandel?: number;
    branslevedandel?: number;
    varavGrovtimmer?: number; //Samma sak som stamblock
    varavKlentimmer?: number;
    tradslag: VKForkalkylTradslagDTO;
}

export class VKSnabbkalkylUtbyteDTO {
    summa: number;
    timmerandel: number;
    produktgrupper: VKSnabbkalkylProduktGruppDTO[];
}

export class VKSnabbkalkylProduktGruppDTO {
    id?: number;
    kvantitetHa: number;
    produktgrupp: VKProduktGruppDTO;
}

export class VKSnabbkalkylDTO {
    id?: number;
    uttagM3FubHa?: number;
    beraknadTid?: Date;
    snabbkalkylTradslag?: VKSnabbkalkylTradslagDTO[];
    utbyte: VKSnabbkalkylUtbyteDTO;
}

export class VKSnabbkalkyl extends VKSnabbkalkylDTO {
    snabbkalkylTradslag: VKSnabbkalkylTradslagDTO[] = [];

    constructor(dto?: VKSnabbkalkylDTO) {
        super();
        if(dto) {
            assign(this, dto);
        }
    }

    get medelstam() {
        if(this.snabbkalkylTradslag.length === 0) {
            return null;
        }

        return meanRoundedWeighted(null, this.snabbkalkylTradslag);
    }

    toMallDto(mallNamn: string) {
        const snabbkalkylmall: VKSnabbkalkylmallDTO = new VKSnabbkalkylmallDTO();
        snabbkalkylmall.namn = mallNamn;
        snabbkalkylmall.kalkylmallTradslag = [];

        this.snabbkalkylTradslag?.forEach((snabbkalkylTradslag: VKSnabbkalkylTradslagDTO, i) => {
            const tradslag: VKForkalkylTradslagDTO = snabbkalkylTradslag.tradslag;

            snabbkalkylmall.kalkylmallTradslag.push({
                andel: snabbkalkylTradslag.andel,
                medelstam: snabbkalkylTradslag.medelstam,
                timmerandel: snabbkalkylTradslag.timmerandel,
                massavedandel: snabbkalkylTradslag.massavedandel,
                granmassavedsandel: snabbkalkylTradslag.granmassavedsandel,
                branslevedandel: snabbkalkylTradslag.branslevedandel,
                varavGrovtimmer: snabbkalkylTradslag.varavGrovtimmer,
                varavKlentimmer: snabbkalkylTradslag.varavKlentimmer,
                tradslag
            });

        });
        return snabbkalkylmall;
    }
}
